import { connect } from 'react-redux';
import subscribeGiftPromoCode from '../../features/subscriptionGiftPromoCode/subscriptionGiftPromoCodeSlice';
import { RootState } from '../../app/store';
import { getMSISDN } from '../../features/auth/selectors';
import PromoCodePage from './PromoCodePage';

const mapStateToProps = (state: RootState) => ({
  msisdn: getMSISDN(state),
});

const dispatchProps = {
  subscribeGiftPromoCode,
};

export default connect(mapStateToProps, dispatchProps)(PromoCodePage);
